import React, { useContext } from 'react';
import LocalizationContext from '../../../Localization/LanguageContext';
import { ILocalizationContext } from '../../../Localization/Models/ILocalizationContext';
import { LandingPage } from '../../../Components/LandingPage/LandingPage';
import { Button } from '@saif/button';
import { AutoLink } from '@saif/link';
import './InvalidInvite.scss';

const InvalidInvite = () => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  return (
    <LandingPage
      iconProps={{ icon: "octagon-exclamation", size: "xxl"}}
      headingProps={{
        size: "xl",
        center: true,
        children: (
          <>
            {getValue('InvalidInvite', 'TitleErrorPrefix')}
            <i>{getValue('InvalidInvite', 'TitleErrorMiddle')}</i>
            {getValue('InvalidInvite', 'TitleErrorSuffix')}
          </>
        )
      }}
      description={
        <>
          <div>
            {getValue('InvalidInvite', 'SubTextPrefix')}&nbsp;
            <AutoLink type="phone" value={getValue('InvalidInvite', 'SubTextPhone')}/>
            &nbsp;{getValue('InvalidInvite', 'SubTextSuffix')}
          </div>
          <Button as="a" id="request-button" variant="fill" color="primary" href="/requestAccess">
            {getValue('InvalidInvite', 'RequestNew')}
          </Button>
        </>
      }
    />
  );
};

export default InvalidInvite;
